import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { CommonStyles, CommonTheme } from '../styles/Styles';
import { AppTheme } from '../styles/AppTheme';
import { Helper } from '../common/helpers/Helper';
import { AppConfig } from '../AppConfig';
import Button from '@material-ui/core/Button';
import { PageAnalytics } from '../common/helpers/PageAnalytics';

export class EmptyMsgView extends Component {
  constructor(props) {
    super(props);
    this.state = {}
  }

  sendAnalytics = () => {
    PageAnalytics.gaTrkEvent(
      'general',
      'phone',
      'EMPTY_VIEW',
      null)
  }

  render() {
    return (
      <div className={css(Styles.noItemsContainer)}>
        {/* <p className={css(Styles.subTitle)}>{this.props.msg || Helper.getString('defaultErrMsg')}</p> */}
        <p className={css(Styles.mainTitle)}>Couldn’t find what you were looking for?</p>
        <div className={css(Styles.subContainer)}>
          <h3 className={css(Styles.assistanceText)}>Send us a direct enquiry</h3>
          <a
            className={css(CommonStyles.link)}
            onClick={() => this.sendAnalytics()}
            href={'tel:' + AppConfig.SUPPORT_PHONE}>
            <Button variant='contained' className={css(Styles.requestButton)}>
              CALL US
            </Button>
          </a>
          <h3 className={css(Styles.assistanceText)}>Or explore {AppConfig.NAME}</h3>
          <a
            className={css(CommonStyles.link)}
            href='/'>
            <Button variant='contained' className={css(Styles.requestButton)}>
              EXPLORE
            </Button>
          </a>
        </div>
      </div>
    )
  }
}

const Styles = StyleSheet.create({
  noItemsContainer: {
    display: 'flex',
    flex: 1,
    minHeight: '60vh',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    margin: AppTheme.pagePadding * 4
  },
  mainTitle: {
    fontSize: 35,
    textAlign: 'center',
    margin: 0
  },
  subTitle: {
    textAlign: 'center',
    fontWeight: 'bolder',
    margin: 0,
    marginBottom: 15,
  },
  subContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: 0
  },
  requestButton: {
    backgroundColor: CommonTheme.textColor,
    color: CommonTheme.white,
    fontWeight: 'bolder',
    padding: '10px 30px'
  },
  assistanceText: {
    fontWeight: 'bolder'
  }
})


// WEBPACK FOOTER //
// ./src/components/EmptyMsgView.js